<template>
  <el-col class="home-list font-13">
    {{dateNow}}
    <el-col>
      <el-col :span="20" class="home-left">
        <span>
          <i class="home-list-number">{{index + 1}}</i>
          <span class="font-18">{{list.name}}</span>
        </span>
        <span class="home-list-money">
          <i>¥</i>
          {{list.platformPrice}}
          <i>起</i>
        </span>
        <span class="font-15">{{list.bedName}}</span>
      </el-col>
      <el-col :span="4" class="text-end">
        <span @click="getRommPrice(list,index)" class="cursor text-offer">
          展开报价
          <i :class="{'el-icon-arrow-down':!hideListShow,'el-icon-arrow-up':hideListShow}"></i>
        </span>
      </el-col>
    </el-col>
    <el-col class="home-hide-list" v-show="hideListShow" v-if="list.ratePlanViewList.length>0">
      <el-col :span="20" class="home-item-title">
        <el-col :span="20">套餐</el-col>
        <el-col :span="4">价格</el-col>
      </el-col>
      <el-col
        class="home-item flex-center"
        v-for="(item,index) in list.ratePlanViewList"
        :key="index"
      >
        <el-col :span="20" class="flex-center-end font-13">
          <el-col class="home-item-text" :span="20">
            <p>{{item.name}}{{item.rateTypeCn}}</p>
            <p>
              <span>{{item.bookingRule}}</span>
              <span>{{item.refundRule}}</span>
            </p>
            <p v-if="item.market">
              <sup>*</sup>
              接收客户类型：{{item.market.indexOf('-1')>=0?'不限制':item.market}}
            </p>
          </el-col>
          <el-col :span="4" class="home-item-money">
            <h3>
              <span class="font-12">¥</span>
              {{item.platformPrice}}
            </h3>
            <sup style="color:black">({{item.coseList.split('|').length}}天总价格)</sup>
          </el-col>
        </el-col>
        <el-col :span="4" class="flex-center">
          <span v-if="Number(item.status) === 2" class="home-item-btn cursor info_button">房满</span>
          <span v-else class="home-item-btn cursor" @click="reserve(item)">预定</span>
        </el-col>
      </el-col>
    </el-col>
  </el-col>
</template>
<script>
import { queryRoomRatePlan } from "@/lib/data-service/hotel";
import { STATUS } from "@/lib/deprecated/utils/status";
import { setSession } from "@/lib/deprecated/utils/caching";

const SUCCESS_CODE = STATUS.success;

export default {
  data() {
    return {
      hideListShow: false,
      homePriceList: [],
      dateNow: this.getCalendarNow
    };
  },
  props: {
    index: {
      type: Number,
      default: 1
    },
    list: {
      type: Object,
      default: {}
    },
    hotelFormDate: {
      type: Object,
      default: {}
    },
    queryList: {
      type: Object,
      default: {}
    },
    hotelId: {
      type: Number,
      default: null
    },
    calendarNow: {
      type: String,
      default: ""
    }
  },
  watch: {
    list(val) {
      this.hideListShow = false;
    }
  },
  methods: {
    reserve(val) {
      let data = {
        hotel: this.list,
        formData: this.hotelFormDate,
        hotelList: this.queryList,
        roomPackage: val
      };
      // console.log('123',data)
      let checkInTime = this.hotelFormDate.checkInTime;
      let checkOutTime = this.hotelFormDate.checkOutTime;
      // let date = this.calendarNow?this.calendarNow:this.$moment().format('YYYY-MM-DD')
      let day = this.datedifference(checkInTime, checkOutTime);
      let time = {
        checkInTime: checkInTime,
        checkOutTime: checkOutTime
      };
      if (!checkInTime || !checkOutTime) {
        return this.$message({
          type: "warning",
          message: "请选择入住、退房日期"
        });
      }
      setSession("HOTELORDERDATA", data);
      setSession("HOTELORDERTIME", time);
      this.$router.push({
        name: "distributor-hotel-front-hotel-reserve"
        // query: { data: JSON.stringify(data), time: JSON.stringify(time) }
      });
    },
    //酒店房型报价
    getRommPrice(val, index) {
      this.hideListShow = !this.hideListShow;
      // let time = this.formData
      // let checkInTime = this.$moment(time.checkInTime).format('YYYY/MM/DD')
      // let checkOutTime = this.$moment(time.checkOutTime).add('days',1).format('YYYY/MM/DD')
      // let data = {
      //     hotelId:this.hotelId,
      //     currentSelectedDate:this.calendarNow?this.calendarNow.replace(/-/g,"/"):this.$moment().format('YYYY/MM/DD'),
      //     roomTypeId:val.roomTypeId
      // }
      // if(this.hideListShow){
      //      queryRoomRatePlan(data).then(res=>{
      //         // console.log('房型报价',res)
      //         if(res.code==SUCCESS_CODE){
      //             this.homePriceList = res.ratePlanResult
      //         }
      //     })
      // }
    },
    //计算天数
    datedifference(sDate1, sDate2) {
      var dateSpan, tempDate, iDays;
      sDate1 = Date.parse(sDate1);
      sDate2 = Date.parse(sDate2);
      dateSpan = sDate2 - sDate1;
      dateSpan = Math.abs(dateSpan);
      iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
      return iDays;
    }
  }
};
</script>
<style lang="less" scoped>
.home-list {
  padding: 20px !important;
  border-top: 1px solid #ccc;
  &:hover {
    // background: #f1f1f1;
  }
  .home-left {
    span {
      display: inline-block;
      padding-right: 20px;
      color: #424242;
    }
  }
  .text-offer {
    color: #3a8acd;
  }
  .home-list-number {
    display: inline-block;
    width: 25px !important;
    height: 25px;
    color: white;
    background: #237dc8;
    font-size: 14px;
    text-align: center;
    line-height: 25px;
    margin-right: 10px;
    font-style: normal;
  }
  .home-list-money {
    color: #ff6600 !important;
    font-size: 16px;
    i {
      font-size: 12px;
      font-style: normal;
    }
  }
  .home-item {
    border-top: 1px solid #eeeeee;
    margin: 5px 0;
    padding: 10px;
    &:nth-child(1) {
      border-top: 1px solid red;
    }
    .home-item-btn {
      padding: 7px 35px;
      background: #ff6600;
      color: white;
      font-size: 16px;
      &.info_button{
        background-color: #909399;
      }
    }
    .home-item-text {
      p {
        padding: 5px 0;
        &:nth-child(1) {
          font-size: 18px;
          color: #424242;
        }
        &:nth-child(2) {
          span {
            border: 1px solid #ccc;
            padding: 3px 10px;
            &:nth-child(1) {
              color: #237dc8;
              border-color: #237dc8;
            }
          }
        }
        &:nth-child(3) {
          color: #7b7b7b;
        }
      }
    }
    .home-item-money {
      color: #ff6600;
      span {
        padding-right: 5px;
      }
    }
  }
  .home-hide-list {
    margin-top: 20px;
    border: solid 1px #eeeeee;
    .home-item-title {
      color: #7b7b7b;
      font-size: 16px;
      padding: 10px;
    }
  }
  .home-item-warn {
    color: #b00;
  }
}
</style>
